import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, Check, ArrowRight } from "lucide-react";

const POINTS = [
  "Finds reviews that violate Google's policies",
  "Disputes and removes illegitimate bad reviews",
  "Protects your Google Business rating and first impression",
];

export const SoftwareSpotlight = () => (
  <section data-testid="software-spotlight" className="mx-auto max-w-7xl px-6 py-24 md:py-32">
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="grid gap-10 rounded-3xl border border-slate-200/80 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] md:grid-cols-2 md:gap-16 md:p-14"
    >
      <div>
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-skybrand">
          Software by Covelli
        </p>
        <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          ReviewShield
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Bad reviews on your Google Business profile cost you customers before
          they ever call. ReviewShield finds and removes the reviews that break
          Google's rules — so your rating finally reflects your real work.
        </p>
        <ul className="mt-8 space-y-3.5">
          {POINTS.map((p) => (
            <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-slate-700">
              <Check size={15} className="mt-0.5 shrink-0 text-skybrand" />
              {p}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col justify-center rounded-2xl border border-kinetic-border bg-kinetic-light p-8 md:p-10">
        <ShieldCheck size={30} className="text-kinetic" />
        <div className="mt-6 flex items-end gap-3">
          <span className="font-display text-6xl font-extrabold tracking-tight text-kinetic">$120</span>
          <span className="pb-2 font-mono text-xs uppercase tracking-widest text-slate-500">CAD</span>
        </div>
        <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-kinetic-hover">
          One-time fee — no subscription, ever
        </p>
        <p className="mt-4 text-sm leading-relaxed text-slate-600">
          Pay once and it's yours. No monthly fees, no renewals, no surprises.
        </p>
        <Link
          to="/software"
          data-testid="spotlight-buy-link"
          className="group mt-8 inline-flex items-center justify-center gap-2 rounded-full bg-kinetic px-8 py-4 font-display text-sm font-bold uppercase tracking-wide text-white transition-colors duration-300 hover:bg-kinetic-hover"
        >
          Get ReviewShield
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </motion.div>
  </section>
);
